import isPropValid from "@emotion/is-prop-valid";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import parseStyle from "./parseStyle";
import useThemeProps from "./useThemeProps.jsx";

const TypographyRoot = styled("p", {
  shouldForwardProp: (prop) =>
    !["style", "color"].includes(prop) && isPropValid(prop),
})`
  ${(props) => parseStyle(props.style, props.theme)}
  color: ${(props) => props.theme.getColor(props.color)};
`;

export default function Typography(props) {
  let theme = useTheme();
  props = useThemeProps({
    props,
    name: "Typography",
  });
  let {
    variant: variantName,
    style,
    children,
    as,
    align,
    elementMapping = {
      h1: "h1",
      h2: "h2",
      h3: "h3",
      h4: "h4",
      h5: "h5",
      h6: "h6",
      body: "p",
      caption: "p",
      description: "p",
    },
    marginBefore = false,
    marginAfter = false,
    color,
    maxLineLength = "80ch",
    ...restProps
  } = props;

  if (Array.isArray(variantName)) {
    variantName = variantName.find(
      (variantName) => theme.typography?.variants?.[variantName],
    );
  }

  let variant = theme.typography?.variants?.[variantName];

  let { element, ...variantStyles } = variant || {};

  as = as || element || elementMapping[variantName];

  style = {
    maxWidth: theme.typography?.maxLineLength || maxLineLength,
    ...variantStyles,
    marginBlockStart: marginBefore ? null : 0,
    marginBlockEnd: marginAfter ? null : 0,
    marginInlineStart: ["right", "end", "center"].includes(align)
      ? "auto"
      : null,
    marginInlineEnd: ["left", "start", "center"].includes(align)
      ? "auto"
      : null,
    textAlign: align,
    ...style,
  };
  return (
    <TypographyRoot as={as} color={color} style={style} {...restProps}>
      {children}
    </TypographyRoot>
  );
}
